import { ApiError, createApiClient, Result, wrapper } from "@/api/base";
import CustomLoginScreenDTO = App.Data.Login.CustomLoginScreenDTO;

const baseClient = createApiClient();

export default class {
	getCustomLoginScreen(): Promise<Result<CustomLoginScreenDTO, ApiError>> {
		return wrapper(baseClient.get(`get-custom-login-screen`));
	}
}
